import React from "react";
import { FileText } from "lucide-react";

export const EndOfLifeCertificates = ({ data }) => {
    if (!data) return null;
    return (
        <section className="panel" data-testid="eol-certificates">
            <div className="px-6 sm:px-8 py-5 border-b hairline">
                <p className="mono-label">Governance extension · 03</p>
                <h2
                    className="font-serif mt-1"
                    style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                >
                    {data.title}
                </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                    <p className="mono-label">Framing</p>
                    <p
                        className="font-serif mt-3"
                        style={{ fontSize: 15.5, lineHeight: 1.55 }}
                    >
                        {data.framing}
                    </p>
                </div>
                <div className="px-6 sm:px-8 py-5">
                    <p className="mono-label">Boundary</p>
                    <p
                        className="mt-3"
                        style={{
                            fontSize: 14,
                            color: "var(--ink-soft)",
                            lineHeight: 1.55,
                        }}
                    >
                        {data.boundary}
                    </p>
                </div>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t hairline">
                {(data.certificates || []).map((c, i) => (
                    <li
                        key={c.key}
                        className={`px-5 py-4 border-b hairline ${
                            (i % 3 !== 2) ? "lg:border-r" : ""
                        } ${(i % 2 === 0) ? "sm:border-r lg:border-r" : ""}`}
                        data-testid={`eol-cert-${c.key}`}
                    >
                        <div className="flex items-start gap-3">
                            <FileText
                                size={16}
                                strokeWidth={1.5}
                                style={{
                                    color: "var(--ink-soft)",
                                    marginTop: 2,
                                }}
                            />
                            <div className="flex-1">
                                <p
                                    className="font-serif"
                                    style={{
                                        fontSize: 15,
                                        lineHeight: 1.35,
                                    }}
                                >
                                    {c.label}
                                </p>
                                <p
                                    className="mono-data mt-1"
                                    style={{
                                        fontSize: 11,
                                        color: "var(--ink-muted)",
                                    }}
                                >
                                    {c.ref}
                                </p>
                                <p
                                    className="mono-label mt-3"
                                    style={{ fontSize: 9.5 }}
                                >
                                    Visible to
                                </p>
                                <p
                                    className="mono-data"
                                    style={{
                                        fontSize: 11,
                                        color: "var(--ink-soft)",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    {(c.visible_to || []).join(" · ")}
                                </p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default EndOfLifeCertificates;
